__webpack_require__.p = "/reports-migrate-to-seconds/referrals-hub/";